import { render, staticRenderFns } from "./mobileStepPlatformNew.vue?vue&type=template&id=dc2be744&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./mobileStepPlatformNew.vue?vue&type=custom&index=0&blockType=scrtipt"
if (typeof block0 === 'function') block0(component)

export default component.exports